// Libraries
import React, { useContext, useEffect, Fragment } from 'react';

// Services and Contexts
import LanguageContext from '../../contexts/LanguageContext';

// Components
import ScreenInfo from '../../components/ScreenInfo';
import IllustrationBasf from '../../components/IllustrationMine';

// Material-UI
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

export default function Welcome() {
  const { translate } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <ScreenInfo title="SCREEN_WELCOME_TITLE" description="SCREEN_WELCOME_INSTRUCTIONS" />
      <Box marginTop={-2} marginLeft={4} marginBottom={4}>
        <Button
          variant="outlined"
          href="https://gmggroup.org/wp-content/uploads/2019/10/GMG_Foundations-of-AI-A-Framework-for-AI-in-Mining-2019-10-07_v01_r01.pdf"
          target="_blank"
          rel="noopener">
          {translate('UI_BUTTON_DOWNLOAD_WHITEPAPER')}
        </Button>
      </Box>
      <IllustrationBasf />
    </Fragment>
  );
}
